




















































































import Vue from 'vue'
import Component from 'vue-class-component'
import AppReleaseList from '@/modules/app-router/components/AppRelease/AppReleaseList.vue'
import Loader from '@/components/Loader.vue';
import ApiVersionList from '@/modules/app-router/components/ApiVersion/ApiVersionList.vue';

@Component({
    components: {ApiVersionList, AppReleaseList, Loader},
})
export default class AppRouterComponent extends Vue {
    public loading = true
    public window = 0
    public bottomTools = false

    /**
     * Al crear el componente solicita a la aplicación la carga de la lista de aplicaciones
     * registradas en el enrutador
     */
    public async created () {
        await Promise.all([
            this.$store.dispatch('appRouter/loadApps'),
            this.$store.dispatch('appRouter/loadApis'),
        ])

        this.loading = false

        const selectedApp = JSON.parse(localStorage.getItem('appRouter.selectedApp') || 'null')
        if (!selectedApp) {
            return
        }

        await this.$store.dispatch('appRouter/loadApp', selectedApp)
    }
}
